import { useState} from "react";
import MediaContext from "./mediaContext";
const MediaState = (props) => {
    const mediaInitial=[];
    const [medias ,setMedia]=useState(mediaInitial)
    
    const getMedia = async(page,myVar)=>{
        if(myVar === undefined)
        {
            myVar='';
        }
        const response = await fetch(`/api/media/${page}?query=${myVar}`, {
            method: "GET"
        
    });
    const json= await response.json();
    setMedia(json)

    }
    return(
        <MediaContext.Provider value={{medias,getMedia}}>
            {props.children}
        </MediaContext.Provider>
    )
}
export default MediaState;